/**
 * The only macro recognition profile. Kept in its own module so both the tree
 * schemas and the calibration contracts can name it without importing each other.
 */
export const MACRO_VISUAL_PROFILE = 'playcast-visual256-v2' as const;
export const MACRO_VISUAL_ITP_PROFILE = 'playcast-visual-itp-v3' as const;
export type MacroVisualProfile = typeof MACRO_VISUAL_PROFILE;
export type MacroVisualItpProfile = typeof MACRO_VISUAL_ITP_PROFILE;
